import React, { useState, useRef, useContext, useEffect, useLayoutEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useHotkeys } from "react-hotkeys-hook";
import Swal from "sweetalert2";

import validErr from "../assets/js/valida";

import "../assets/css/modal.css";
import FloatingMenu from './comun/FloatingMenu';

//Contexto
import ConexContext from "../context/conex/ConexContext";

//imágenes
import { ReactComponent as CuotaIcon } from "../assets/img/iconos/acae_fees.svg";
import { ReactComponent as GuardarIcon } from "../assets/img/iconos/acae_save.svg";
import { ReactComponent as CloseIcon } from "../assets/img/close2.svg";
import { ReactComponent as AcaeArrow } from "../assets/img/iconos/acae_arrow.svg";
import { ReactComponent as OptionsIcon } from "../assets/img/iconos/acae_options.svg";
import desc from "../assets/img/desc_gris.svg";
import asc from "../assets/img/asc_gris.svg";

const RemesasMod = (props) => {
	const WaitSearch = require('../config/config.json').WaitSearch;
	const { peticion, loc, Cargando } = useContext(ConexContext);
	const navigate = useNavigate();
	const { lang } = useParams();

	//atajos de teclado
	useHotkeys("alt+g", guarda, {
		enableOnContentEditable: true,
		enableOnFormTags: true,
		enabled: props.show !== 0 && !Cargando,
	});
	useHotkeys("esc", cierra, {
		enableOnContentEditable: true,
		enableOnFormTags: true,
		enabled: props.show !== 0 && !Cargando,
	});

	//STATES
	const [Filtro, setFiltro] = useState(""); // Filtro
	const [FiltroAux, setFiltroAux] = useState(""); // FiltroAux
	const [Anio, setAnio] = useState(""); // selec de años
	const [NumAd, setNumAd] = useState(0); // cuotas de adultos
	const [NumNi, setNumNi] = useState(0); // cuotas de niños
	const [ListParams, setListParams] = useState({
		orden: "numAcae",
		anio: "",
		selec: [],
		recarga: false,
	});
	const [List, setList] = useState([]); // listo alumnos
	const [Lectura, setLectura] = useState(false); //está en modo lectura

	const [ErrAnio, setErrAnio] = useState(""); // Error en el nombre
	const [ErrList, setErrList] = useState(""); // Error en el listado
	const [activeMenu, setActiveMenu] = useState(null);
	const [Estado, setEstado] = useState('');
	const menuRefs = useRef({});
	// const [animIdx, setAnimIdx] = useState({idAso:0,pos:0,add:true});
	const rowRefs = useRef({});
	const prevPos = useRef({});
	const [toggled, setToggled] = useState(null);

	//REFs
	const rAnio = useRef();
	const rNumAd = useRef();
	const rNumNi = useRef();
	const rFiltr = useRef();
	const timeoutRef = useRef(null);

	const handleChange = () => {
		setFiltroAux(rFiltr.current.value);
		// Limpiamos cualquier timeout anterior
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Esperamos 1.5 segundos desde la última tecla
		timeoutRef.current = setTimeout(() => {
			if (rFiltr.current){
				setFiltro(rFiltr.current.value);
			}
		}, WaitSearch);
	};

	//quita o pone un elemento del Select
	const toggleSelec = (idAso) => {
		if (Lectura) return;

		const el = rowRefs.current[idAso];
		if (el) {
			const { top } = el.getBoundingClientRect();
			prevPos.current[idAso] = top;
		}

		const newSelec = ListParams.selec.includes(idAso)
			? ListParams.selec.filter(x => x !== idAso)
			: [...ListParams.selec, idAso];

			setToggled(idAso);
		setListParams(p => ({ ...p, selec: newSelec }));
	};

	useLayoutEffect(() => {
		if (toggled == null) return;
		const el = rowRefs.current[toggled];
		const oldTop = prevPos.current[toggled];
		if (!el || oldTop == null) return;

		const newTop = el.getBoundingClientRect().top;
		const offset = oldTop - newTop;

		el.style.transition = 'transform 0s';
		el.style.transform = `translateY(${offset}px)`;

		requestAnimationFrame(() => {
			el.style.transition = 'all 0.5s ease-in-out';
			el.style.transform = '';
		});

		if (el) {
			el.classList.add('modified');
			setTimeout(() => {
				if (el) el.classList.remove('modified');
			}, 2000);
		}

		delete prevPos.current[toggled];
		setToggled(null);
		// eslint-disable-next-line
	}, [ListParams.selec]);

	//EFFECT
	useEffect(() => {
		async function ver() {
			const pet = await peticion("/cuotas/ver?id=" + props.show);
			if (pet.estado)
				//algún error
				return;
			try {
				setListParams((prev) => ({
					...prev,
					selec: pet.res.selec,
					anio: pet.res.anio,
					recarga: true,
				}));
				rAnio.current.focus();
				if (pet.res.cfValDojo !== 0) setLectura(true);
			} catch (e) {}
		}
		// console.log('props.show',props.show);
		if (props.show > 0) ver();
		else if (props.show < 0) {
			setAnio("");
			setNumAd(0);
			setNumNi(0);
			setListParams((prev) => ({
				...prev,
				anio: "",
			}));
			rAnio.current.focus();
		}
		// eslint-disable-next-line
	}, [props.show]);
	// useEffect(() => {console.log('List',List)}, [List]);
	// ha cambiado el año: hay que consultar los alumnos
	useEffect(() => {
		async function listAlum() {
			const pet = await peticion(
				`/cuotas/listAlum?anio=${Anio}&orden=${ListParams.orden}&id=${props.show}`
			);
			if (pet?.estado ?? true)
				//algún error
				return;
			setList(pet?.res ?? []);
			setListParams((prev) => ({
				...prev,
				recarga: false,
			}));
		}
		if (ListParams.recarga && Anio !== ListParams.anio) {
			//Se quiere cargar el listado
			setAnio(ListParams.anio);
			return; //se volverá a llegar y ya listar directamente
		}
		if (Anio === "") {
			//el usuario ha seleccionado sin año
			setList([]);
			return;
		}
		if (Anio !== ListParams.anio)
			setListParams((prev) => ({
				...prev,
				selec: [],
				anio: Anio,
				recarga: true,
			}));
		else if (ListParams.recarga) listAlum();
		// eslint-disable-next-line
	}, [Anio, ListParams, props.show]);
	useEffect(() => {
		if (props.show === 0) return;
		let nA = 0;
		let nN = 0;
		List.forEach((e) => {
			if (ListParams.selec.includes(e.idAso)) {
				if (e.tipo === "A") nA++;
				else nN++;
			}
		});
		setNumAd(nA);
		setNumNi(nN);
	}, [List, ListParams.selec, props.show]);
	// guardar el registro
	async function guarda() {
		let error = false;
		//requeridos
		error |= validErr(Anio === "", setErrAnio, loc("El año es requerido."));
		error |= validErr(
			List.length > 0 && ListParams.selec.length === 0,
			setErrList,
			loc("Debes marcar al menos un asociado.")
		);
		// filtros sin necesidad de peticiones
		if (error)
			//algún error
			return;
		let pet;
		if (props.show < 0)
			//inserción
			pet = await peticion("/cuotas/ins", {
				method: "POST",
				json: {
					anio: Anio,
					selec: ListParams.selec,
				},
			});
		else if (props.show > 0)
			//modificación
			pet = await peticion("/cuotas/mod", {
				method: "POST",
				json: {
					id: props.show,
					anio: Anio,
					selec: ListParams.selec,
				},
			});
		let id = pet?.res?.id ?? props.show;
		if (pet.estado)
			//algún error
			return;
		cierra();
		if (parseInt(id) === props.ListParams.idReg)
			props.setListParams((prev) => ({ ...prev }));
		else {
			navigate(`/${lang}/app/cuotas/${id}`);
		}
	}
	//cierra el modal
	function cierra() {
		setFiltroAux("");
		setFiltro("");
		setEstado("");
		setErrAnio("");
		setErrList("");
		setList([]);
		setAnio("");
		setLectura(false);
		props.onHide();
	}
	//cierra el modal
	function orden(campo) {
		if (ListParams.orden === campo) campo = campo + " DESC";
		setListParams({
			...ListParams,
			orden: campo,
			recarga: true,
		});
	}

	List.sort((a, b) => a.selec - b.selec);

	function getCuotasModActions(elem) {
		const acciones = [];

		acciones.push({
			label: loc("Ir a la ficha del asociado"),
			icon: <AcaeArrow className="icon" />,
			link: true,
			href: `/${lang}/app/asociados/usuario/${elem.numAcae}`,
		});

		return acciones;
	}

	const accionesPorAsociado = List.reduce((acc, elem) => {
		acc[elem.idAso] = getCuotasModActions(elem);
		return acc;
	}, {});
	
	const toggleMenu = (id) => {
		setActiveMenu(activeMenu === id ? null : id);
	};

	// const showAcciones = Object.values(accionesPorAsociado).some(
	// 	(a) => a.length > 0
	// );

	if (props.show === 0) return "";
	else
		return (
			<main className="modal-wrapper">
				<div className="modal-container backdrop content-wrapper">
					<div className="modal-header">
						<div className="flex-wrapper">
							<CuotaIcon className="section-icon cuotas" />
							<h3>
								{props.show > 0 ? loc("Modificar remesa") : loc("Nueva remesa")}
							</h3>
						</div>
						<CloseIcon
							onClick={()=>{
								if (Estado==="modificado"){
									Swal.fire({
										title: loc("¿Hay valores modificados, estás seguro que quieres salir sin aplicar los cambios?"),
										showCancelButton: true,
										confirmButtonText: loc("Sí"),
										icon: "question",
										cancelButtonText: loc("No"),
									}).then((result) => {
										if (result.isConfirmed){
											cierra();
										}
									})
								}else{
									cierra();
								}
							}}
							className="modal_close-icon"
							alt="Cerrar ventana"
							title="(ESC)"
						/>
					</div>
					<div className="modal-content-scroll form-container">
						<div className="modal-content-outer-wrapper">
							<div className="flex-wrapper padding-bottom">
								<div className="flex-row-item full-width">
									<div className="equal-width relative-container">
										<p>{loc("Año")}:</p>
										<select
											className="equal-width"
											disabled={Lectura}
											ref={rAnio}
											value={Anio}
											onChange={() => {
												setErrAnio("");
												setAnio(rAnio.current.value);
											}}>
											<option value={""}>{loc("Seleccionar año")}</option>
											{Array(50)
												.fill(new Date().getFullYear() + 1)
												.map((elem, i) => (
													<option value={elem - i} key={i}>
														{elem - i}
													</option>
												))}
										</select>
										{ErrAnio ? <p className="error">{ErrAnio}</p> : ""}
									</div>
									<div className="equal-width">
										<p>{loc("Número de cuotas de adultos")}:</p>
										<input
											style={{ textAlign: "right" }}
											disabled
											ref={rNumAd}
											value={NumAd}
										/>
									</div>
									<div className="equal-width">
										<p>{loc("Número de cuotas de niños")}:</p>
										<input
											disabled
											style={{ textAlign: "right" }}
											ref={rNumNi}
											value={NumNi}
										/>
									</div>
								</div>
							</div>
							<div className='relative-container'>
								<input
									ref={rFiltr}
									placeholder={loc("Filtrar")}
									onChange={handleChange}
									value={FiltroAux}
								/>
								<p className="error"></p>
							</div>
						</div>
						<div className="table-container">
							<table className="table-cuotas-mod">
								<thead className="table-headers">
									<tr key="cabeceradatostabla" style={{ width: "100%" }}>
										{/* <th style={{ width: '20%' }}>
											<button onClick={() => orden('numAcae')}>{loc('Núm. ACAE')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'numAcae' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'numAcae DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th> */}
										<th className='tiny-column'>
										</th>
										<th className='medium-column'>
										</th>
										<th className='large-column'>
											<button onClick={() => orden("numAcae")}>
												{loc("Num ACAE")}
											</button>
											<ul className="listaordena">
												{ListParams.orden === "numAcae" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
												{ListParams.orden === "numAcae DESC" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											</ul>
										</th>
										<th>
											<button onClick={() => orden("nombre")}>
												{loc("Nombre")}
											</button>
											<ul className="listaordena">
												{ListParams.orden === "nombre" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
												{ListParams.orden === "nombre DESC" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											</ul>
										</th>
										<th>
											<button onClick={() => orden("apellido")}>
												{loc("Apellidos")}
											</button>
											<ul className="listaordena">
												{ListParams.orden === "apellido" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
												{ListParams.orden === "apellido DESC" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											</ul>
										</th>
										<th className="wide-column">
											<button onClick={() => orden("tipo")}>
												{loc("Tipo")}
											</button>
											<ul className="listaordena">
												{ListParams.orden === "tipo" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
												{ListParams.orden === "tipo DESC" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											</ul>
										</th>
										<th className="wide-column">
											<button onClick={() => orden("ultima_cuota")}>
												{loc("Cuota")}
											</button>
											<ul className="listaordena">
												{ListParams.orden === "ultima_cuota" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
												{ListParams.orden === "ultima_cuota DESC" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											</ul>
										</th>
									</tr>
								</thead>
								<tbody className="table-results">
									{List.filter((elem) =>
										` ${elem?.numAcae ?? ""} ${elem?.nombre ?? ""} ${
											elem?.apellido ?? ""
										}`
											.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
											.includes(Filtro.toUpperCase())
									).sort((a, b) => {
										const aSeleccionado = ListParams.selec.includes(a.idAso);
										const bSeleccionado = ListParams.selec.includes(b.idAso);
										if (aSeleccionado && !bSeleccionado) return -1; // a va antes
										if (!aSeleccionado && bSeleccionado) return 1;  // b va antes
										return 0; // mantener orden relativo
									}).map((elem, i) =>
										Lectura & !ListParams.selec.includes(elem.idAso) ? null : (
											<tr
												key={elem.idAso}
												ref={el => rowRefs.current[elem.idAso] = el}
												className={
												elem.selec
													? 'not-clickable'
													: ListParams.selec.includes(elem.idAso)
													? 'clickable selected'
													: 'clickable'
												}
												>
												<td className="table-button tiny-column">
													<div
														className="menu-wrapper"
														ref={(el) =>
															(menuRefs.current[elem.idAso] = el)
														}>
														<OptionsIcon
															onClick={() => toggleMenu(elem.idAso)}
															className="table-button__icon black"
														/>
														{activeMenu === elem.idAso && (
															<FloatingMenu
																anchorRef={{
																	current: menuRefs.current[elem.idAso],
																}}
																onClose={() => setActiveMenu(null)}
																id={elem.idAso}>
																{accionesPorAsociado[elem.idAso].map(
																	(accion, i) =>
																		accion.link ? (
																			<li key={i}>
																				<Link
																					className="no-decoration"
																					to={accion.href}>
																					{accion.icon}
																					<span>{accion.label}</span>
																				</Link>
																			</li>
																		) : (
																			<li key={i} onClick={accion.onClick}>
																				{accion.icon}
																				<span>{accion.label}</span>
																			</li>
																		)
																)}
															</FloatingMenu>
														)}
													</div>
												</td>
												<td className="medium-column">
													{!Lectura ? (
														<div
															className={`inscripcion estado-container ${elem.selec && "disabled"}`}
															onClick={() => {
																setEstado('modificado');
																toggleSelec(elem.idAso);
															}}
														>
															{ListParams.selec.includes(elem.idAso) ? loc("Quitar") : loc("Añadir")}
														</div>
													) : null}
												</td>
												<td className='large-column'>{elem.numAcae}</td>
												<td className='table-button black ocultamovil' style={{ width: "20%" }}>
													{elem?.nombre}
												</td>
												<td>{elem.apellido}</td>
												<td className="wide-column">
													{elem.tipo === "A" ? loc("Adulto") : loc("Niño")}
												</td>
												<td className="wide-column">
													{elem.ultima_cuota}
												</td>
											</tr>
										)
									)}
								</tbody>
							</table>
							<div>
								<p className="error">{ErrList}</p>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="flex-wrapper flex-end">
							{!Lectura && (
								<div className="flex-wrapper flex-end">
									<button
										type="button"
										onClick={guarda}
										className="button primary ">
										{loc("Aplicar")}
										<GuardarIcon alt={loc('Aplicar')} title={loc('Aplicar')} />
									</button>
									<p className="error"></p>
								</div>
							)}
							<button className="button tertiary" onClick={()=>{
								if (Estado==="modificado"){
									Swal.fire({
										title: loc("¿Hay valores modificados, estás seguro que quieres salir sin aplicar los cambios?"),
										showCancelButton: true,
										confirmButtonText: loc("Sí"),
										icon: "question",
										cancelButtonText: loc("No"),
									}).then((result) => {
										if (result.isConfirmed){
											cierra();
										}
									})
								}else{
									cierra();
								}
							}}>
								{loc("Cancelar")}
							</button>
						</div>
					</div>
				</div>
			</main>
		);
};

export default RemesasMod;
